import {
    receiveShipmentUrl,
    getReceiveCodeUrl,
    shipmentHoldOrderUrl,
    shipmentShipUrl,
    checkOrderStatusUrl,
    cancelOrderUrl,
    updateShipmentUrl,
    f1OrderReceiveUrl,
    uploadFileUrl,
    f1UpdateOrderUrl,
    saveAbnormalRecordUrl,
    rejectProxyDeliveryPackageUrl,
    receiveProxyDeliveryPackageUrl,
} from 'Utils/urlUtil';
import util from 'Utils/commonUtil';
import {T} from 'Actions/translate';

export default (errorMsg, url, method, params, data, requestType) => {
    switch (errorMsg) {
        // case 'bad_request':
        // case 'sql_syntax_error':
        // case 'internal_server_error':
        //     if(url === receiveShipmentUrl) return '收货失败，服务器出现异常';
        //     if(url === shipmentHoldOrderUrl) return '暂不发货失败，服务器出现异常';
        //     if(url === shipmentShipUrl) return '发货失败，服务器出现异常';
        //     if(url === checkOrderStatusUrl) return '服务器出现异常';
        //     if(url === cancelOrderUrl) return '取消订单失败，服务器出现异常';
        //     if(url === saveAbnormalRecordUrl) return '添加失败，服务器出现异常';
        //     break;
        case 'version_error':
        case 'concurrent_data_access_error':
            if (url === receiveShipmentUrl)
                return (
                    T('notification_goods_failed') +
                    ',' +
                    T('notification_refresh_page')
                );
            if (url === shipmentHoldOrderUrl)
                return (
                    T('notification_delivery_failed') +
                    ',' +
                    T('notification_refresh_page')
                );
            if (url === shipmentShipUrl)
                return (
                    T('notification_delivery_failure') +
                    ',' +
                    T('notification_refresh_page')
                );
            if (url === cancelOrderUrl)
                return (
                    T('notification_order_cancellation_failed') +
                    ',' +
                    T('notification_refresh_page')
                );
            break;
        case 'invalid_status':
        case 'invalid_orderStatus':
            if (url === receiveShipmentUrl)
                return (
                    T('notification_goods_failed') +
                    ',' +
                    T('notification_no_delivery_order')
                );
            if (url === shipmentHoldOrderUrl)
                return (
                    T('notification_delivery_failed') +
                    ',' +
                    T('notification_no_shipment_order')
                );
            if (url === shipmentShipUrl)
                return (
                    T('notification_delivery_failure') +
                    ',' +
                    T('notification_no_shipment_order')
                );
            if (url === cancelOrderUrl)
                return (
                    T('notification_order_cancellation_failed') +
                    ',' +
                    T('notification_order_not_cancelled')
                );

            if (url === getReceiveCodeUrl) {
                return T('shippment_upload_send_code_status_incorrect');
            }
            break;
        case 'invalid_orderId':
        case 'invalid_shipmentId':
            if (url === receiveShipmentUrl)
                return (
                    T('notification_goods_failed') +
                    ',' +
                    T('notification_order_not_found')
                );
            if (url === shipmentHoldOrderUrl)
                return (
                    T('notification_delivery_failed') +
                    ',' +
                    T('notification_order_not_found')
                );
            if (url === shipmentShipUrl)
                return (
                    T('notification_delivery_failure') +
                    ',' +
                    T('notification_order_not_found')
                );
            if (url === checkOrderStatusUrl)
                return T('notification_order_not_found');
            if (url === updateShipmentUrl)
                return (
                    T('notification_change_failed') +
                    ',' +
                    T('notification_order_not_found')
                );
            if (url === cancelOrderUrl)
                return (
                    T('order_cancel_order') +
                    ',' +
                    T('notification_order_not_found')
                );
            break;
        case 'invalid_quantity':
        case 'invalid_product_quantity':
            if (url === shipmentShipUrl)
                return (
                    T('notification_delivery_failure') +
                    ',' +
                    T('notification_delivery_quantity_error')
                );
            if (url === f1UpdateOrderUrl)
                return T('notification_replenishment_quantity_error');
            break;
        case 'invalid_orderProduct':
        case 'invalid_orderProductId':
            if (url === shipmentShipUrl)
                return (
                    T('notification_delivery_failure') +
                    ',' +
                    T('notification_product_sent_wrong')
                );
            break;
        case 'order_partially_cancel_not_allowed':
            if (url === cancelOrderUrl)
                return T('notification_order_cannot_be_partially_cancelled');
            break;
        case 'duplicated_orderProductId':
            if (url === f1OrderReceiveUrl)
                return (
                    T('notification_goods_failed') +
                    ',' +
                    T('notification_product_repeatedly')
                );
            break;
        case 'host_no_sc':
            if (url === saveAbnormalRecordUrl)
                return (
                    T('notification_addition_failed') +
                    ',' +
                    T('notification_no_sc')
                );
            break;
        case 'invalid_physicalInventory':
            if (url === saveAbnormalRecordUrl)
                return (
                    T('notification_addition_failed') +
                    ',' +
                    T(
                        'notification_the_number_of_exceptions_exceeds_the_actual_inventory',
                    )
                );
            if (url === shipmentShipUrl)
                return (
                    T('notification_delivery_failure') +
                    ',' +
                    T(
                        'notification_the_quantity_shipped_exceeds_the_actual_stock',
                    )
                );
            break;
        case 'unknown_sku':
            if (url === saveAbnormalRecordUrl)
                return (
                    T('notification_addition_failed') +
                    ',' +
                    T('notification_sku_not_exist')
                );
            break;
        case 'sc_unknown_sku':
            if (url === saveAbnormalRecordUrl)
                return (
                    T('notification_addition_failed') +
                    ',' +
                    T('notification_sku_not_valid')
                );
            break;
        case 'invalid_lock':
            if (url === shipmentShipUrl) return T('notification_invalid_lock');
            break;
        case 'quantity_incorrect':
            if (url === shipmentShipUrl)
                return T('shipment_sku_incorrect', [data.message]);
            break;
        case 'has_unread_message':
            if (url === shipmentShipUrl) return T('shipment_unread_message');
            break;
        case 'file_too_large':
            if (url === uploadFileUrl)
                return T('lto_purchase_upload_file_image_too_large', [
                    util.getMaxFileSize(data.message),
                ]);
            break;
        case 'image_too_large':
            if (url === uploadFileUrl) return T('upload_image_too_large');
            break;
        case 'bad_file_format':
            if (url === uploadFileUrl) {
                if (
                    requestType === 'proxy_delivery' ||
                    requestType === 'receipt' ||
                    requestType === 'location_image'
                ) {
                    return T(
                        'proxy_delivery_package_upload_file_bad_file_format',
                    );
                } else {
                    return T('lto_purchase_upload_file_bad_file_format');
                }
            } else {
                return T('lto_purchase_upload_file_bad_file_format');
            }
        case 'invalid_receiving_code':
            if (url === receiveShipmentUrl)
                return T('notification_receive_code_mismatch');
            break;
        case 'invalid_phone_number':
            if (url === getReceiveCodeUrl)
                return T('shippment_upload_send_code_tel_incorrect');
            break;
        case 'INVALID_REJECT_TYPE':
            if (url === rejectProxyDeliveryPackageUrl)
                return T('proxy_delivery_reject_type_incorrect');
            break;
        case 'SHIPMENT_COMPLETED':
            if (url === rejectProxyDeliveryPackageUrl)
                return T('proxy_delivery_package_complete_not_reject');
            break;
        case 'SHIPMENT_NOT_ALLOEWED_REJECTED':
            if (url === rejectProxyDeliveryPackageUrl)
                return T('proxy_delivery_package_not_allowed_reject');
            break;

        case 'SHIPMENT_STATUS_NOT_ALLOWED':
            if (url === receiveProxyDeliveryPackageUrl)
                return T(
                    'proxy_delivery_package_status_not_allowed_to_receive',
                );
            break;
        case 'SHIPMENT_NOT_EXIST':
            if (url === receiveProxyDeliveryPackageUrl)
                return T('proxy_delivery_package_SHIPMENT_NOT_EXIST');
            break;
        default:
            if (url === receiveShipmentUrl)
                return T('notification_goods_failed');
            // if(url === shipmentHoldOrderUrl) return T('notification_delivery_failed');
            if (url === shipmentShipUrl)
                return T('notification_delivery_failure');
            if (url === uploadFileUrl)
                return T('notification_file_upload_failed');
            // if(url === saveAbnormalRecordUrl) return T('notification_addition_failed');
            break;
    }
};
